import axios from 'axios';
import { socket } from './socket';

const baseURL = `${import.meta.env.VITE_API_BASE_ENDPOINT}`;

if (!baseURL) {
  throw new Error('Base URL not set!');
}

const httpClient = axios.create({
  baseURL,
});

// Tells the server which socket initiated a change so it can stamp
// envelope.actorSocketId — the client's echo-skip identity (audit §4.2).
httpClient.interceptors.request.use((config) => {
  if (socket.connected && socket.id) {
    config.headers['x-socket-id'] = socket.id;
  }
  return config;
});

export default httpClient;
